import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface IBuyersFilter {
  search?: string;
  input_groups_guid: IInputGroupsFilter[];
  order_by: string;
  selected_cities_id?: string;
  has_immediate: boolean;
}

export interface ISerach {
  search: string;
}

export interface IInputGroupsFilter {
  guid: string;
  title: string;
}

const initialState: IBuyersFilter = {
  search: '',
  input_groups_guid: [],
  order_by: '',
  selected_cities_id: '',
  has_immediate: false,
};

export const buyersSlice = createSlice({
  name: 'buyers',
  initialState,
  reducers: {
    findBuyers: (state, action: PayloadAction<IBuyersFilter>) => {
      state.input_groups_guid = action.payload.input_groups_guid;
      state.order_by = action.payload.order_by;
      state.has_immediate = action.payload.has_immediate;
      state.selected_cities_id = action.payload.selected_cities_id;
    },
    findBuyersBySerach: (state, action: PayloadAction<ISerach>) => {
      state.search = action.payload.search;
    },
    resetBuyersList: (state, action: PayloadAction<IBuyersFilter>) => {
      state.input_groups_guid = action.payload.input_groups_guid;
      state.order_by = action.payload.order_by;
      state.has_immediate = action.payload.has_immediate;
      state.selected_cities_id = action.payload.selected_cities_id;
    },
    clearBuyerList: state => {
      state.input_groups_guid = [];
      state.order_by = '';
      state.has_immediate = false;
      state.selected_cities_id = '';
    },
  },
});

export const {findBuyers, findBuyersBySerach, resetBuyersList, clearBuyerList} =
  buyersSlice.actions;

export default buyersSlice.reducer;
